import { FC, useEffect } from 'react';

import { useGetUser } from 'app/api/hooks/core/v1/auth/user';
import { useGetPayeePromotionalCampaigns } from 'app/api/hooks/core/v1/payee/promotionalCampaigns';
import { PropsWithOnlyChildren } from 'app/types';
import { formatDate } from 'app/utils/lib/dates';

export interface MedalliaVariables {
  /* eslint-disable @typescript-eslint/naming-convention */
  // CompanyAlias: string; // only used in Audit
  CompanyDOT: string;
  CompanyID: string;
  CompanyMC: string;
  CompanyName: string;
  // CompanyTMS: string; // only used in Audit
  CompanyType: string;
  Email: string;
  Product: string;
  ProfileType: string;
  PromotionalCampaignElected: string;
  PromotionalCampaignEndDate: string;
  PromotionalCampaignPayorName: string;
  UserID: string;
  UserName: string;
  UserRole: string;
  /* eslint-enable @typescript-eslint/naming-convention */
}

// Component Definition
const MedalliaProvider: FC<PropsWithOnlyChildren> = props => {
  const wdw = window;
  const user = useGetUser();
  const promotionalCampaignData = useGetPayeePromotionalCampaigns();

  const firstCampaign = promotionalCampaignData.data?.promotionalCampaigns[0];

  useEffect(() => {
    if (!wdw.medallia && user?.company) {
      wdw.medallia = {
        /* eslint-disable @typescript-eslint/naming-convention */
        CompanyDOT: user.company.dotNumber ?? '',
        CompanyID: user.company.id ?? '',
        CompanyMC: user.company.mcNumber ?? '',
        CompanyName: user.company.name,
        CompanyType: user.company.displayName?.match(/\(([^)]+)\)/)?.[1] ?? '',
        Email: user.email ?? '',
        Product: location.hostname,
        ProfileType: user.company.type.name ?? '',
        PromotionalCampaignElected: (!!firstCampaign?.quickpayElectedDate
          && !!firstCampaign.relationshipClaimedDate).toString() ?? '',
        PromotionalCampaignEndDate: formatDate(firstCampaign?.endDate),
        PromotionalCampaignPayorName: firstCampaign?.payor.name ?? '',
        UserID: user.id ?? '',
        UserName: user.name ?? '',
        UserRole: user.roles?.map(role => role.name).join(', ') ?? '',
        /* eslint-enable @typescript-eslint/naming-convention */
      };
    }

    return () => {
      wdw.medallia = undefined;
    };
  }, [firstCampaign, user, wdw]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {props.children}
    </>
  );
};

export default MedalliaProvider;
